import { ModButton } from '@moderneinc/design-system-components';
import { semanticColors, typography } from '@moderneinc/design-system-tokens';
import type { FunctionComponent } from 'react';
import { DOCUMENTATION_SITE_URL } from '../../constants/general';

const SEARCH_DOCS_URL = `${DOCUMENTATION_SITE_URL}/user-documentation/moderne-platform/how-to-guides/moderne-platform-search`;

export const SearchDocs: FunctionComponent = () => {
  return (
    <ModButton
      variant="tertiary"
      size="small"
      onClick={() => window.open(SEARCH_DOCS_URL, '_blank', 'noopener')}
      // Match the mock: 13px, link blue (tertiary would render navy).
      sx={{
        fontSize: `${typography.fontSize.caption}px`,
        color: semanticColors.color.text.link
      }}
    >
      Search syntax tips
    </ModButton>
  );
};
